module.exports = __webpack_public_path__ + "ba765df9a314a0c62e0cfc032748dfe4.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-50.cur
// module id = 462
// module chunks = 0